import { render, staticRenderFns } from "./SideBasket.vue?vue&type=template&id=88c54fb8&scoped=true&"
import script from "./SideBasket.vue?vue&type=script&lang=js&"
export * from "./SideBasket.vue?vue&type=script&lang=js&"
import style0 from "./SideBasket.vue?vue&type=style&index=0&id=88c54fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c54fb8",
  null
  
)

export default component.exports